import DOMPurify from 'dompurify'

// Salesforce rich-text fields often include inline styles and basic formatting tags.
// DOMPurify strips scripts/event handlers while preserving safe markup. On top of
// that baseline we harden against non-script abuse the default HTML profile still
// permits: phishing forms, page-wide <style> blocks, and external resource beacons
// (e.g. tracking pixels). Reverse tab-nabbing needs no handling here because the
// html profile already strips the `target` attribute, so links stay same-context.
const SANITIZE_CONFIG = {
  USE_PROFILES: { html: true },
  // Forbids these elements only — the safe inline `style` *attribute* used for
  // Salesforce formatting is intentionally left untouched.
  FORBID_TAGS: [
    'form',
    'input',
    'textarea',
    'select',
    'option',
    'button',
    'style',
  ],
}

let hooksRegistered = false

function registerHooks() {
  if (hooksRegistered) return
  hooksRegistered = true

  // Block external resource loads (tracking pixels / IP beacons) while still
  // allowing inline data: images to render.
  DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (
      node.hasAttribute('src') &&
      !/^data:/i.test(node.getAttribute('src') || '')
    ) {
      node.removeAttribute('src')
    }
    if (node.hasAttribute('srcset')) {
      node.removeAttribute('srcset')
    }
  })
}

registerHooks()

export function looksLikeHtml(value) {
  return typeof value === 'string' && /<\/?[a-z][\s\S]*>/i.test(value)
}

export default function sanitizeHtml(dirtyHtml) {
  if (dirtyHtml == null || dirtyHtml === '') return ''
  return DOMPurify.sanitize(String(dirtyHtml), SANITIZE_CONFIG)
}
